import { useId } from 'react';
import EditableLable from '../../../../../common/labels/EditableLabel/EditableLable';
import classes from './TimesheetItem.module.scss';

export default function TimesheetItem(props) {
  const { day, value, changeHandler, disabled = false, justForInfo = false } = props;
  const id = useId();

  return !justForInfo ? (
    <div className={classes.container}>
      <p className={classes.day}>{day}</p>
      <EditableLable key={id} value={value} changeHandler={changeHandler} disabled={disabled} />
    </div>
  ) : (
    <div className={classes.infoContainer}>
      <p className={classes.dayInfo}>{day}</p>
      <p className={classes.valueInfo}>{value}</p>
    </div>
  );
}
